import React, {Component} from 'react';
import PropTypes from 'prop-types';

import ReorderableList from '../../gd-ui/sortable-list-3/reorderable-list';
import ItemView from './item-row';
import ItemAdd from './item-add';

import Classes from 'classnames';
import _ from 'lodash';

export default class ItemsListEditor extends Component {
    static propTypes = {
        items: PropTypes.array,
        incSeed: PropTypes.number,
        addLabel: PropTypes.string,

        colorSelectionEnabled: PropTypes.bool,

        onChange: PropTypes.func
    };

    static defaultProps = {
        items: [],
        colorSelectionEnabled: false
    };

    constructor(props, context) {
        super(props, context);
        let newIncSeed = props.incSeed;

        let initialItems = props.items;
        if (!initialItems || initialItems.length === 0) {
            initialItems = [
                {id:++newIncSeed, value:"Option 1", sortPosition: 0},
                {id:++newIncSeed, value:"Option 2", sortPosition: 0}
            ];
            // set form field value if not set yet
            this.onChange(initialItems, newIncSeed);
        }

        this.state = {
            items: initialItems,
            incSeed: newIncSeed
        };
    }

    onChange = (items, newIncSeed) => {
        if (this.props.onChange) this.props.onChange(items, newIncSeed);
    };

    onAddItem = () => {
        const newIncSeed = this.state.incSeed + 1;
        const items = _.cloneDeep(this.state.items);
        items.push({id:newIncSeed, value:"", sortPosition: 0});

        this.setState({items:items, incSeed:newIncSeed},()=>{this.onChange(items, newIncSeed); if (this.lastItemView) this.lastItemView.focus()});
    };

    onDragEnd = (items) => {
        items.map((i,key)=>{i.sortPosition = key;});
        this.setState({items:items},()=>{this.onChange(items, this.state.incSeed)});
    }

    onDeleteItem = (item) => {
        let items = _.cloneDeep(this.state.items);
        const index = items.indexOf(_.find(items, i=>i.id === item.id));
        if (index !== -1) items.splice(index,1);

        this.setState({items:items},()=>{this.onChange(items, this.state.incSeed)});
    };

    onItemRename = (id, value) => {
        const items = _.cloneDeep(this.state.items);
        const item = _.find(items, i=>i.id === id);
        item.value = value;
        this.setState({items:items},()=>{this.onChange(items, this.state.incSeed)});
    };

    onItemChangeColor = (id, value) => {
        const items = _.cloneDeep(this.state.items);
        const item = _.find(items, i=>i.id === id);
        item.color = value;

        this.setState({items:items},()=>{this.onChange(items, this.state.incSeed)});
    };


    render() {
        const classes = Classes("options-list", this.props.className);

        const lastItemKey = this.state.items.length - 1;
        const components = this.state.items.map((item, key)=>({
            item: item,
            component: <ItemView key={key}
                                 ref={r=>{if (lastItemKey === key) this.lastItemView = r}}
                                 item={item}
                                 colorSelectionEnabled={this.props.colorSelectionEnabled}
                                 onItemRename={this.onItemRename}
                                 onItemChangeColor={this.onItemChangeColor}
                                 onDeleteClick={this.state.items.length > 1 ? this.onDeleteItem : null}/>
        }));

        return (
            <div className="items-list-editor">
                <ReorderableList className={classes}
                                 items={components}
                                 onDragEnd={this.onDragEnd}
                                 dragSourceType="reorderableOptionsList"/>

                <ItemAdd label={this.props.addLabel} onClick={this.onAddItem}/>
            </div>
        )
    }
}